import React from 'react';
import Card from './Card/Card';

export default function Keywords({ title, words = [] }) {
  if (!words.length) return null;

  return (
    <Card title={title}>
      <ul data-name="keywords" className="horizontal-bullet-list">
        {words.map(word => (
          <li key={word}>
            {word}
          </li>
        ))}
      </ul>
    </Card>
  );
}



// WEBPACK FOOTER //
// ./src/universal/ui/components/Keywords.js